import { COLORS, ContentIcons, LoadingIndicator, PageWidth } from "@laerdal/life-react-components";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Topics, { TopicItem } from "../../commonComponents/Topics";
import Subtopics from "../../commonComponents/Subtopics";
import ProductSupport from "./components/ProductSupport";
import LaerdalPrograms from "./components/LaerdalPrograms";
import LandingHeader from "./components/LandingHeader";
import { useEffect, useState } from "react";
import { ProductCategoryDto } from "../../model/dto/productCategoryDto";
import ProductApi from "../../services/api/ProductApi";
import QuickLinks from "../../commonComponents/QuickLinks";
import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from "../../store/slices/userSlice";
import ContactSupport from "../../commonComponents/ContactSupport";
import posthog from 'posthog-js';


const Page = styled(PageWidth)`
  padding: 0 32px;
  
  margin-bottom: 40px;
  margin-top: 40px;
  gap: 40px;
  
  display: flex;
  flex-direction: column;
`;

const PageContainer = styled.div`
margin-top: 20px;
margin-bottom: 60px;
`;

const PopularTopics = styled.div`
  display:flex;
  flex-direction:column;
  
  gap: 16px;
  
`;
const PopularTopicsHeading = styled.div`
  color: ${COLORS.black};

  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px; /* 116.667% */
  padding-bottom: 16px;
`;

const SubtopicsWrapper = styled.div`
  background-color: ${COLORS.neutral_50};
  padding: 20px 0;
`;

const LandingPage = () => {
  const { t, i18n } = useTranslation("landingPage");

  const [categoriesLoading, setCategoriesLoading] = useState<boolean>(true);
  const [categories, setCategories] = useState<ProductCategoryDto[]>([]);
  const [topicItems, setTopicItems] = useState<TopicItem[]>([]);

  const isAuthenticated = useSelector(selectIsAuthenticated);

  useEffect(() => {
    ProductApi
      .GetProductCategories()
      .then((data) => {
        setCategoriesLoading(false);
        setCategories(data);
        let topics = data.map((x) => ({
          text: x.name,
          asset: x.mainImageUrl,
          heightPx: "144px",
          link: `category/${x.linkName}`
        }));

        setTopicItems(topics);
      })
  }, [i18n.language]);

  return (
    <>
      <LandingHeader />
      <PageContainer>

        <Page $useMaxWidth={true} $maxWidth={1024}>

          <QuickLinks />

          <ContactSupport />
          <PopularTopics>
            <PopularTopicsHeading>{t('Product Categories')}</PopularTopicsHeading>
            {categoriesLoading &&
              <LoadingIndicator />
            }
            {topicItems.length > 0 &&
              <Topics
                items={topicItems}
                onItemClick={(item) => {
                  const cat = categories.find(c => c.name === item.text);
                  posthog?.capture('SUPP-LandingPage-CategoryClick', {
                    categorycode: cat?.linkName,
                    categorytext: item.text,
                  });
                }}
              />
            }
          </PopularTopics>
        </Page>

        <SubtopicsWrapper>
          <Page $useMaxWidth={true} $maxWidth={1024}>
            <Subtopics
              items={[{
                icon: <ContentIcons.Download size="48" color={COLORS.black} />,
                text: t('Downloads'),
                link: process.env.REACT_APP_DOWNLOAD_LINK ?? ''
              }, {
                icon: <ContentIcons.Stock size="48" color={COLORS.black} />,
                text: t('Product Returns'),
                link: "https://www.laerdal.com/us/support/ordering-shipping/product-returns/"
              }, {
                icon: <ContentIcons.Video size="48" color={COLORS.black} />,
                text: t('How-To Videos'),
                link: "https://www.laerdal.com/support/how-to-videos/"
              }, {
                icon: <ContentIcons.PhysiologicalModel size="48" color={COLORS.black} />,
                text: t('Parts Catalogue'),
                link: "https://www.laerdal.com/support/catalog/"
              }, {
                icon: <ContentIcons.ProvidersOrders size="48" color={COLORS.black} />,
                text: t('Ordering & Shipping'),
                link: "https://www.laerdal.com/support/ordering-shipping/"
              }, {
                icon: <ContentIcons.Terms size="48" color={COLORS.black} />,
                text: t('Laerdal Global Warranty'),
                link: "https://cdn.laerdal.com/downloads/f4781/Att1toPRO-ML01-0295.pdf"
              }
              ]}
            />
          </Page>
        </SubtopicsWrapper>

        <Page $useMaxWidth={true} $maxWidth={1024}>

          <ProductSupport />
          <LaerdalPrograms />

        </Page>
      </PageContainer>
    </>);
};

export default LandingPage;